<template>
  <div class="person-info">
    <!-- 用户信息 -->
    <div class="top">
      <div class="user">
        <img class="avatar" :src="profile.userAvatarUrl" alt />
        <div class="rightx">
          <!-- 昵称、VIP皇冠 -->
          <h1 class="rowspan">
            <span class="rowspan">{{profile.userNickName}}</span>
            <img v-if="profile.identityType != 0" src="@/assets/imgs/vip.png" alt />
          </h1>
          <!-- 会员到期提示 -->
          <p v-if="profile.identityType == 0">{{noneVIPText()}}</p>
          <p v-else>
            <span v-if="profile.identityType == 1">会员</span>
            <span v-if="profile.identityType == 2">VIP</span>
            <span v-if="profile.identityType == 3">会员</span>
            <span>{{profile.vipInfo==null?'2099-01-01':profile.vipInfo[profile.identityType == 2?'SUPER':'ORDINARY'].vipExpireData}}到期</span>
            <el-popover
              v-if="profile.identityType == 3"
              class="hoverx"
              placement="top-end"
              width="230"
              trigger="hover"
            >
              <p>超级会员到期时间：{{profile.vipInfo==null?'2099-01-01':profile.vipInfo['SUPER'].vipExpireData}};</p>
              <p>优先使用超级会员权益</p>
              <i class="el-icon-more" slot="reference"></i>
            </el-popover>
          </p>
          <!-- 续费按钮 -->
          <p class="cursor-pointer" v-if="profile.tips">
            <a
              v-spm="spmJudge()"
              class="spm"
              href="https://mall.csdn.net/vip?utm_source=vipqyy_hysf_xf"
              target="_blank"
            >
              <span v-html="profile.tips"></span>
            </a>
            <img src="@/assets/imgs/across_right.png" alt />
          </p>
        </div>
      </div>
      <!-- Tab -->
      <ul>
        <li :class="tab == 0? 'is-active':''" @click="tabChange(0)">我的权益</li>
        <!-- <li :class="tab == 1? 'is-active':''" @click="tabChange(1)">我的证书</li> -->
      </ul>
    </div>
    <!-- 内容 -->
    <div class="content-range" :class="tab == 0?'ffffff':'fdfdfd'">
      <!-- 个人权益列表 -->
      <div class="quan" v-show="tab == 0" v-for="(item,index) in permissionInfoList" :key="item.id">
        <img :src="item.permissionIcon" alt />
        <a
          v-report="{spm:'1003.2449.3001.7923', index}"
          v-query="'1003.2449.3001.7923'"
          class="text module-click"
          :href="item.permissionUrl"
          target="_blank"
        >{{item.permissionTips}}</a>
      </div>

      <!-- 个人权益到期列表 -->
      <div
        class="quan quan-none"
        v-show="tab == 0"
        v-for="item in permissionInfoListNone"
        :key="item.id"
      >
        <img :src="item.permissionIcon" alt />
        <a
          v-spm="'1003.2449.3001.7923'"
          class="text module-click"
          href="https://mall.csdn.net/vip?utm_source=vipqyy_hysf_xf"
          target="_blank"
        >{{item.permissionTips}}</a>
      </div>

      <!-- 个人权益占位列表 -->
      <div
        class="quan"
        v-show="tab == 0"
        v-for="item in (permissionInfoList.length + permissionInfoListNone.length) % 4"
        :key="item"
      ></div>

      <!-- 我的证书列表 -->
      <!-- <div class="zheng" v-show="tab == 1" v-for="item in certificateList" :key="item.id">
        <div v-if="item.received" class="tag">已获得</div>
        <div class="nei">
          <img :src="item.url" alt />
          <h1 class="rowspan">{{item.certificateName}}</h1>
          <p class="rowspan">{{item.courseName}}</p>
        </div>
        <div class="hover">
          <button
            @click="item.received?downloadCertificate(item.url, item):openUrl('https://edu.csdn.net/lab/', undefined,item.courseId)"
          >{{item.received?'我要下载':'我要获取'}}</button>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { getLoginInfo, getCertificates } from "@/utils/api";

export default {
  data() {
    return {
      tab: 0,
      profile: {},
      permissionInfoList: [],
      permissionInfoListNone: [],
      certificateList: [],
    };
  },
  mounted() {
    this.TabDate();
  },
  methods: {
    // 内容Tab切换
    tabChange(tab) {
      this.tab = tab;
      this.TabDate();
    },
    // 卡片内容切换
    TabDate() {
      if (this.tab === 0) {
        getLoginInfo().then(({ data }) => {
          var temp_list = [];
          var none_list = [];
          // 不同会员的权益做一个整合 放入权限列表和权限灰度列表
          data.ownerEquities.vipInfoList.forEach((item) => {
            if (item.isVip) {
              item.permissionInfoList.forEach((single) => {
                temp_list.push(single);
              });
            } else {
              item.permissionInfoList.forEach((single) => {
                none_list.push(single);
              });
            }
          });
          this.profile = data || [];
          this.permissionInfoList = temp_list;
          this.permissionInfoListNone = none_list;
        });
      } else if (this.tab === 1) {
        getCertificates().then((response) => {
          this.certificateList = response.data.data;
        });
      }
    },
    openUrl(url, spm, id) {
      if (spm !== undefined) {
        window.open(url + "?spm=1003.2449." + spm);
      } else if (id !== undefined) {
        window.open(url + id);
      } else {
        window.open(url);
      }
    },
    // 续费接口
    renewal() {
      window.open("https://mall.csdn.net/vip?utm_source=vipqyy_hysf_xf");
    },
    // 下载证书绘制
    downloadCertificate(url, item) {
      let image = new Image();
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);

        context.font = "normal 70px Han Sans CN";
        context.fillStyle = "#000000";
        context.textAlign = "center";
        context.fillText(item.username, image.width / 2, 900);

        context.font = "normal 120px Han Sans CN";
        context.fillStyle = "#b06904";
        context.textAlign = "center";
        context.fillText(item.certificateName, image.width / 2, 1350);

        context.font = "normal 50px Han Sans CN";
        context.fillStyle = "#000000";
        context.textAlign = "center";
        context.fillText(item.createdTime, 750, 1650);

        context.font = "normal 60px Han Sans CN";
        context.fillStyle = "#000000";
        context.textAlign = "left";
        context.fillText(item.certificateNo, 500, 2100);

        let url = canvas.toDataURL("image/png");
        let a = document.createElement("a");
        let event = new MouseEvent("click");
        a.download = item.certificateName || "qrcode.jpg";
        a.href = url;
        a.dispatchEvent(event);
      };
      image.src = url;
    },
    // 不同会员埋点选择
    spmJudge() {
      switch (this.profile.identityType) {
        // 无会员
        case 0:
          // 且之前拥有过VIP
          if (
            this.profile.vipInfo["SUPER"] ||
            this.profile.vipInfo["ORDINARY"]
          ) {
            return "1003.2449.3001.7921";
          }
          return "1003.2449.3001.7920";
        // 普通会员
        case 1:
        // 超级会员
        case 2:
        // 双料会员
        case 3:
          return "1003.2449.3001.7922";
      }
    },
    // VIP过期文案 分为会员和超级会员
    noneVIPText() {
      if (this.profile.vipInfo["SUPER"]) {
        return (
          "超级会员已于" + this.profile.vipInfo["SUPER"].vipExpireData + "过期"
        );
      } else if (this.profile.vipInfo["ORDINARY"]) {
        return (
          "会员已于" + this.profile.vipInfo["ORDINARY"].vipExpireData + "过期"
        );
      } else {
        return "开通CSDN会员";
      }
    },
  },
};
</script>

<style lang="less">
.person-info {
  margin-bottom: 10px;

  .top {
    padding: 24px;
    padding-bottom: 0;
    border: 2px;
    background: #fff;
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.04);

    .user {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .avatar {
        border-radius: 56px;
        width: 56px;
        height: 56px;
        background: rgba(0, 0, 0, 0.2);
      }

      .rightx {
        width: 224px;
        display: flex;
        flex-direction: column;

        .spm {
          color: #555666;
          text-decoration: none;
        }

        h1 {
          display: flex;
          align-items: center;
          font-size: 18px;
          font-weight: 500;
          color: #222226;
          line-height: 26px;

          img {
            margin-left: 4px;
            width: 24px;
            height: 24px;
            object-fit: cover;
          }
        }

        p {
          display: flex;
          align-items: center;
          margin-top: 4px;
          font-size: 14px;
          font-weight: 400;
          color: #555666;
          line-height: 22px;

          em {
            font-style: normal;
            color: #fc5531;
            cursor: pointer;
          }

          img {
            width: 16px;
            height: 16px;
            object-fit: cover;
            cursor: pointer;
          }

          .hoverx {
            flex: 1;
            text-align: right;
            display: flex;
            flex-direction: column;

            i {
              cursor: pointer;
            }

            p {
              font-size: 12px;
              background: #fff;
            }
          }
        }
      }
    }

    ul {
      margin-top: 16px;
      width: 100%;
      height: 29px;
      display: flex;
      list-style: none;

      li {
        margin-right: 32px;
        border-bottom: 3px solid transparent;
        font-size: 14px;
        font-weight: 400;
        color: #999aaa;
        line-height: 22px;
        cursor: pointer;
      }

      .is-active {
        color: #222226;
        border-bottom: 3px solid #222226;
      }
    }
  }

  .content-range {
    border-radius: 0 0 2px 2px;
    padding: 0 24px;
    padding-bottom: 10px;
    width: 290px;
    height: 272px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    overflow-y: auto;
    border: 1px solid #f0f0f2;

    .quan-none {
      opacity: 0.5;
    }

    .quan {
      margin-top: 8px;
      width: 66px;
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        margin-bottom: 5px;
        width: 50px;
        height: 50px;
        border-radius: 2px;
        object-fit: cover;
      }

      .text {
        display: block;
        font-size: 12px;
        font-weight: 400;
        color: #69421b;
        line-height: 16px;
        text-align: center !important;
      }
    }

    .zheng {
      position: relative;
      border-radius: 2px;
      margin-top: 8px;
      width: 137px;
      height: 110px;
      display: flex;
      justify-content: center;
      background: #ffffff;
      box-shadow: 0px 8px 16px -4px rgba(0, 0, 0, 0.06);

      .nei {
        position: relative;
        z-index: 1;
        padding: 4px;
        width: 129px;
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
          margin-bottom: 4px;
          width: 66px;
          height: 66px;
          background: #f5f6f7;
          border-radius: 2px;
        }

        h1 {
          width: 129px;
          margin-bottom: 4px;
          font-size: 14px;
          font-weight: 400;
          color: #555666;
          line-height: 20px;
        }

        p {
          width: 129px;
          font-size: 12px;
          font-weight: 400;
          color: #999aaa;
          line-height: 16px;
        }
      }

      .hover {
        display: none;
      }

      .tag {
        position: absolute;
        z-index: 3;
        top: 0;
        left: 0;
        padding: 2px 8px;
        background: rgba(34, 34, 38, 0.7);
        border-radius: 2px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 24px;
        text-align: center;
      }
    }

    .zheng:hover {
      .hover {
        position: absolute;
        z-index: 2;
        width: 137px;
        height: 110px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.1);
        border-radius: 2px;
        backdrop-filter: blur(2px);
        cursor: pointer;

        button {
          width: 70px;
          height: 24px;
          background: #fc5531;
          border-radius: 14px;
          font-size: 12px;
          font-weight: 400;
          color: #ffffff;
          line-height: 16px;
        }
      }
    }
  }

  .ffffff {
    background: #ffffff;
  }

  .fdfdfd {
    background: #fdfdfd;
  }

  .content-range::-webkit-scrollbar {
    display: none;
  }
}
</style>